import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react'; // Импортируем хуки для работы с Auth0
import "./SohnLuzifers/Tag144.css";
import { Helmet } from 'react-helmet-async';

const Krug: React.FC = () => {

  const { isAuthenticated, loginWithRedirect } = useAuth0(); // Получаем статус авторизации и функцию входа

  return (

  <div className="breadcrumbs">

    <Helmet>
    <title>Феникс - Сергей Мавроди: Общение со Вселенной</title>
    <meta
      name="description"
      content="Феникс: узнайте, как общаться со Вселенной через любовь и оргазм с 00:00 до 00:15. Присоединяйтесь к сообществу Сергея Мавроди!"
    />
    <meta name="keywords" content="Сергей Мавроди, Феникс, Вселенная, любовь, оргазм, духовность, резонанс" />
    <meta name="author" content="Сергей Мавроди" />
    <meta property="og:title" content="Феникс - Сергей Мавроди" />
    <meta
      property="og:description"
      content="Феникс: общайтесь со Вселенной через любовь с 00:00 до 00:15. Присоединяйтесь к сообществу Сергея Мавроди."
    />
    <meta property="og:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://sergey-mavrodi.com/krug" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="ru_RU" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Феникс - Сергей Мавроди" />
    <meta
      name="twitter:description"
      content="Феникс: общайтесь со Вселенной через любовь с 00:00 до 00:15. Присоединяйтесь к сообществу Сергея Мавроди."
    />
    <meta name="twitter:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <link rel="canonical" href="https://sergey-mavrodi.com/krug" />
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'Феникс',
        'description': 'Феникс: страница Сергея Мавроди о духовном общении со Вселенной через любовь и оргазм с 00:00 до 00:15.',
        'url': 'https://sergey-mavrodi.com/krug',
        'image': 'https://sergey-mavrodi.com/images/portrait.webp',
        'publisher': {
          '@type': 'Organization',
          'name': 'Сергей Мавроди',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Главная',
              'item': 'https://sergey-mavrodi.com/',
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': 'Феникс',
              'item': 'https://sergey-mavrodi.com/krug',
            },
          ],
        },
        'contactPoint': {
          '@type': 'ContactPoint',
          'email': 'mmm-2011@sergey-mavrodi.com',
          'contactType': 'customer support',
        },
      })}
    </script>
  </Helmet>

    <div className="breadcrumb">
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → ФЕНИКС
      </div>
    </div>
    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>ФЕНИКС</h2>
            <div style={{ backgroundColor: 'white' }}>

<br /><br /><br />  
<div className="note" style={{ backgroundColor: 'rgb(205, 205, 205)' }}>
<p><em>Я был самым обычным человеком, таким же точно, как и все вы. Я никогда раньше не думал всерьёз ни о Боге, ни о Вселенной. Как и многие из вас, наверное, никогда не думают. Всё это всегда представлялось мне слишком абстрактным, далёким и ко мне лично прямого отношения не имеющим. Как, конечно же, и многим из вас представляется. Но, когда я был в аду, на одной из самых страшных якутских зон, куда меня и засунули-то, собственно, в надежде, что я там сдохну как собака! так вот там, в этом аду, мне вдруг стали с некоторых пор сниться странные сны…</em></p>
<p><em>Всё нижеизложенное, все эти откровения привиделись мне во сне. Почему Вселенная избрала именно меня, я не знаю. Да это и не важно. Важно лишь, что отныне я – Избранный, Мессия. И это накладывает на меня обязательства. Я должен поделиться этим своим новым знанием со всеми вами, с людьми. Я чувствую в этом потребность, я просто не могу иначе! Что я и делаю. Иных целей у меня нет.</em></p>

<p>Есть, несомненно, что-то высшее. Бог, Космический Разум, Вселенная, Система… <Link to="/terms" style={{ color: 'blue'}}>&lt;см. СТРАНИЦУ 1&gt;</Link> А значит, с этим Чем-то (или Кем-то!) в принципе можно общаться. Обращаться к нему. Например, молитва – это и есть простейший пример такого именно обращения. Прямого. Непосредственно к Богу. Минуя всех посредников – священников и пр.</p>

<p>Но это только в принципе! Поскольку реально общаться чрезвычайно сложно. Огромные, немыслимые и не представимые даже расстояния,.. рассеяние,.. слабенький, еле слышимый, микроскопический совсем сигнал, посылаемый каждым отдельным человеком,.. индивидом… В общем, шансы, что твоё послание будут услышано – крайне невелики. Призрачны. Люди это ещё с древнейших времён понимали и учитывали: не случайно существуют церкви, храмы и т.п. – т.е. места, где люди собираются вместе, специально для того, чтобы совместно помолиться. Этот совместный, общий сигнал имеет уже гораздо б<strong><em>о</em></strong>льшую мощность, а значит, и б<strong><em>о</em></strong>льшие шансы быть услышанным. Тем более, что когда люди думают об одном, например, о Боге, их мысли работают словно на одной частоте, в унисон, попадают в резонанс, поэтому не просто суммируются, а усиливаются многократно.</p>
<p>Но есть тут и свой минус. Если ты будешь думать в церкви не о божественном (не в резонансной частоте храма), то мысли твои до Бога не дойдут. Об этом тоже все испокон веков знают: в церкви нужно думать только о Боге, о хорошем, о благих делах. С плохими к Богу обращаться нельзя.</p>
<p>Однако есть и второй путь. Как усилить сигнал. Не собираться всем вместе, а просто молиться всем в одно и то же время. Т.е. согласование не в пространстве (церковь), а во времени. Тогда эффект будет тот же самый. Одновременно – значит, опять же, резонансные частоты, многократное усиление и пр.</p>
<p>Именно так, кстати, поступают мусульмане. Они совершают в течение дня свои намазы (или как там у них называется?) в строго определённое время. Где бы они в этот момент ни находились. Более того, обязательно поворачиваются при этом лицом на восток. Что тоже имеет определённый смысл. С точки зрения усиления сигнала.</p>
<p>Всё это ясно. Но ахиллесова пята всех этих общений с Богом – настроение. Попадание в резонансные частоты. Трудно настроиться на молитву. Настроение может быть плохое или, наоборот, слишком хорошее; что-то может мешать, отвлекать и т.д. и т.п. К тому же люди все разные. У каждого свои представления о добре и зле, свои представления о боге, а значит, и частота сигнала у каждого своя. Поэтому полного резонанса добиться почти никогда не удаётся. А значит, и максимального усиления. Не случайно, опять же, подлинные чудеса случались всегда в самые критические моменты истории, когда все люди, весь народ, в едином порыве молили Бога об одном и том же (скажем, о спасении Отечества), а значит, и частоты у всех практически совпадали. Энергетический поток был, таким образом, чрезвычайно силён.</p>
<p>Итак, резюмируем. Главная задача при обращении ко Вселенной – попасть в резонансную частоту со всеми другими обращающимися, молящимися. Тогда есть шанс, что твой сигнал всё-таки дойдёт. Средство достижения этой цели – гипотеза Бога. Все верующие представляют его примерно единообразно – неважно, кто это: Иисус, Аллах, Кришна… – на основании религиозной литературы, икон, и пр., а потому частота сигнала у всех приверженцев одной религии примерно одинаковая.</p>
<p>Но есть и ещё один путь! Общения со Вселенной. Иной! Не религиозный! Как попасть в резонанс частоты со всеми остальными. Причём независимо от вероисповедания. Одинаковые эмоции! Боль, скажем. Или секс. Оргазм! Все люди испытывают в этот момент примерно одно и то же, поскольку физиология у всех нас одна, единая, а значит, и частоты в этот момент у всех одинаковые. Причём интенсивность переживания гарантирует это! Что частоты будут у всех одинаковые. Тут уже не имеют значения ни настроение, никакие отвлекающие факторы. Оргазм смывает всё! Пик его. Это едва ли вообще не самое интенсивное переживание, которое только может испытывать человек, и при этом хоть что-то ещё думать и соображать.</p>
<p><strong><em>Таким образом, вот подлинный путь к счастью. Любовь! Самое прекрасное чувство на свете.</em></strong></p>
<p>Выбираем определённое время, вернее, интервал времени, скажем, с 00.00 (полночь лучше всего! полночь это вообще особое время) до 00.15, и постарайтесь в этот период испытать оргазм, одновременно загадывая желание. Посылать Вселенной свой сигнал, зная, что именно сейчас, в эти самые мгновенья, с 00.00 до 00.15, это делают вместе с вами одновременно и все остальные члены нашей организации, нашего сообщества, и, следовательно, сигнал ваш усиливается, усиливается и усиливается!.. Растёт! Многократно! <strong><em>Канал общения со Вселенной открыт!!</em></strong></p>
<p>И само сознание, с<strong><em>а</em></strong>мая мысль, что этим в данный момент, именно в это самое мгновенье! занимаются все!.. все сейчас вот прямо испытывают наслаждение, оргазм! кончают все!! одновременно!!! – разве она не возбуждает вас?! не подстёгивает! не заводит?! не усиливает ещё больше Ваши эмоции, чувства, страсти, переживанья?</p>
<p><strong><em>И прекрасно! Чем лучше Вам – тем лучше всем. Тем больше шансов, что наш сигнал – Ваш сигнал! – будет Вселенной услышан, и Ваше желание сбудется.</em></strong></p>

<div className="text-center" style={{ textAlign: 'center' }}>
  <strong>
    <span style={{ color: 'red' }}>ИТАК!!! С </span>
    <span style={{ color: 'yellow' }}>00.00 ДО 00.15</span>
    <span style={{ color: 'red' }}> ЕЖЕДНЕВНО!!!</span>
  </strong>
</div>
<br />


<div className="text-center" style={{textAlign: 'center', color: 'red'}}><strong>ЭТО ВРЕМЯ ОБЩЕНИЯ С СИСТЕМОЙ!!!</strong></div><br />
<div className="text-center" style={{textAlign: 'center', color: 'red'}}><strong>КАНАЛ ОБЩЕНИЯ СО ВСЕЛЕННОЙ ОТКРЫТ!</strong></div><br />
<div className="text-center" style={{textAlign: 'center', color: 'yellow'}}><strong>ИСПЫТЫВАЙТЕ ОРГАЗМ В ЭТОТ МОМЕНТ ВМЕСТЕ С ТЫСЯЧАМИ И</strong></div>
<div className="text-center" style={{textAlign: 'center', color: 'yellow'}}><strong>ТЫСЯЧАМИ ДРУГИХ ЛЮДЕЙ, МУЖЧИН И ЖЕНЩИН,</strong></div>
<div className="text-center" style={{textAlign: 'center', color: 'yellow'}}><strong>И ПОСЫЛАЙТЕ ЕЙ СВОЁ ЖЕЛАНИЕ.</strong></div>
<div className="text-center" style={{textAlign: 'center', color: 'yellow'}}><strong>И ОНО ОБЯЗАТЕЛЬНО СБУДЕТСЯ!!!</strong></div><br />
<br />

 {/* Замена "ВХОД" на кнопку "Личный кабинет" */}
    <div className="parent-container">
      {isAuthenticated ? (
        <Link
          to="/lk"
          className="demo_but144"
          aria-label="Перейти в Личный кабинет"
          title="Перейти в Личный кабинет"
        />
      ) : (
        <button
          className="demo_but144"
          onClick={() => loginWithRedirect()}
          aria-label="Войти в Личный кабинет"
          title="Войти в Личный кабинет"
          role="button"
        />
      )}
    </div>
                  <br /><br /><br />

<div className="text-center" style={{textAlign: 'center'}}>Вы не верите, сомневаетесь, колеблетесь? Вы не верите в силу Любви?<br />
А Вы просто попробуйте, и всё!!!<br />
Ничего же не требуется, никаких усилий, затрат и пр.<br />
И Вы сразу увидите, как Ваша жизнь изменится к лучшему! Сразу же!!
<br /><br />
Сообщайте всем своим друзьям и знакомым об этом сайте!<br />
Чем больше нас будет, тем более мощным и сильным будет,<br />
соответственно, наш совместный сигнал-послание.<br />
И тем больше шансов, что он будет услышан Системой.<br />
Успехов! Всё у Вас сбудется!</div><br />
<div className="text-center" style={{textAlign: 'center'}}>Если Вам что-то непонятно, если у Вас возникли какие-то вопросы – пишите мне! Пишите также о всех своих удачах и проблемах. Особенно об удачах! Я опубликую Ваше письмо на сайте, его прочтут другие люди – и нас станет ещё больше! И наше совместное послание Системе станет ещё мощнее. Пишите обязательно!</div>
<br />

<div className="text-center" style={{ textAlign: 'center' }}>
  Мой e-mail:{' '}
  <strong><a
    href="mailto:mmm-2011@sergey-mavrodi.com"
    style={{ color: 'blue'}} 
    className="email-link"
    aria-label="Отправить письмо на mmm-2011@sergey-mavrodi.com"
  >
    mmm-2011@sergey-mavrodi.com
  </a></strong>
</div>
<br />
<br />
<br />
</div>




            </div>
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);
};

export default Krug;
